import React from "react";
import styled from "styled-components";
import { Color, Spacing, ZIndexes } from "@glossy";
import { useZIndex } from "@lkf/hooks";
import Icon from "@ui-kit/icon";
import SafeHTML from "@ui-kit/safe-html";

export const BANNER_TYPES = ["info", "warn"] as const;

interface IProps {
  message: string;
  type: typeof BANNER_TYPES[number];
  sticky?: boolean;
  onClose: () => void;
}

const Root = styled.div<{ type: IProps["type"] }>`
  background-color: ${(props) =>
    props.type === "info" ? Color.Bisque : "#F09D9A"};
  height: 50px;
  color: ${Color.Black};
  padding: ${Spacing.ExtraSmall} ${Spacing.Medium};
  display: flex;
  flex-shrink: 0;
  column-gap: ${Spacing.Medium};
  align-items: center;
  line-height: 19px;
`;

const StyledIcon = styled(Icon)`
  flex-shrink: 0;
`;

const Message = styled.div`
  flex-grow: 1;
  overflow: hidden;
  max-height: 100%;
`;

const Close = styled(Icon)`
  flex-shrink: 0;
  cursor: pointer;
`;

const UiKitAppBanner = ({ message, type, sticky, onClose }: IProps) => {
  const rootRef = useZIndex(ZIndexes.AppBanner, sticky);

  return (
    <Root type={type} ref={rootRef}>
      <StyledIcon
        glyph={type === "info" ? "circle-info" : "circle-bang"}
        size="m"
      />
      <SafeHTML as={Message} html={message} />
      <Close onClick={onClose} glyph="cross" size="s" />
    </Root>
  );
};

export default UiKitAppBanner;
